<micro-select-combo #sel
              placeholder="Outgoing Mailbox"
              routerBase="mail/smtp"
              valueField="email"
              [mode]="mode"
              [(id)]="smtpId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
              platformService="maild"
>
</micro-select-combo>
